// extracted by mini-css-extract-plugin
export default {"supplier":"Style_supplier__j6-b5","content":"Style_content__rcGR5","description":"Style_description__ZIwXz","bordered":"Style_bordered__bFHPa"};